import { Component, OnInit } from '@angular/core';
import {UserService} from '../../Services/Users.service';
import {Router} from '@angular/router';
declare var $;

@Component({
  selector: 'app-community',
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.css']
})
export class CommunityComponent implements OnInit {

  show: boolean = true;
  showBulkRegistration: boolean;

  constructor(private router: Router, private userService: UserService ) {

  }

  ngOnInit() {
    const currentUser = localStorage.getItem('currentUser');
    const commId = JSON.parse(currentUser).user.community_id;
    this.userService.getCommunityByCommunityID(commId).subscribe(res => {
      // if(res.success){
        if(res.data.config && res.data.config.length > 0){
          this.showBulkRegistration = res.data.config[0].bulk_registration;
        } else {
          this.showBulkRegistration = false;
        }
      // }
    });
  }
  gotoNew(){
   this.router.navigate(['/User']);
  }
  toggleSidenav(){
    $('.menu').toggleClass('width240');
    $('.menu').toggleClass('width90');
    $('.text').toggle(280);
    $('.mainCommunity').toggleClass('marginLft70');
    $('.leftArrow').toggleClass('rightArrow');
    $('.rightArrowAlign').toggleClass('leftArrowAlign');
    $('.submenu-body').toggleClass('submneu-nopadding');
  }

  toggleMenuSub(){
    $('.subArrow').toggleClass("subArrowRotate");
  }

  toggle() {
    this.show = !this.show;
  }

}



// WEBPACK FOOTER //
// ./src/app/Screens/community/community.component.ts